/* harmony-range — centers the featured card in the mobile scroll track.
   Contract: <harmony-range> wraps the section content; [data-h-range-track]
   is the snap-x scroller, [data-h-range-featured] the slide to center.
   Centers on connect + resize; desktop keeps scrollLeft 0. */
(function () {
  'use strict';
  if (customElements.get('harmony-range')) return;
  customElements.define(
    'harmony-range',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-h-range-track]');
        this.featured = this.querySelector('[data-h-range-featured]');
        if (!this.track || !this.featured) return;
        this.center();
        window.addEventListener('resize', () => this.center());
      }

      center() {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.track.scrollLeft = 0;
          return;
        }
        const offset =
          this.featured.offsetLeft - (this.track.clientWidth - this.featured.offsetWidth) / 2;
        this.track.scrollLeft = offset;
      }
    }
  );
})();
